import { ThemeIcon } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';

interface BooleanCellProps {
  value: boolean;
}

/**
 * Renders a boolean value as a colored badge with checkmark or X icon.
 */
export function BooleanCell({ value }: BooleanCellProps) {
  const IconComponent = value ? IconCheck : IconX;
  return (
    <ThemeIcon color={value ? 'green.4' : 'red.5'} radius="xl" size="xs">
      <IconComponent size="70%" stroke={5} />
    </ThemeIcon>
  );
}
